function debounce (func, wait, immediate) {
  var timeout;
  return function () {
    var context = this; var args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

function deferLoad () {
  // once we've been called, there's no need to call again
  window.removeEventListener('scroll', debouncedDeferLoad);

  // Deferred images
  var $deferable = $('[data-src]');
  $deferable.each(function () {
    $(this).attr('src', $(this).data('src'));
  });

  // Deferred css backgrounds
  $('.js-defer-load').removeClass('js-defer-load');
};

var debouncedDeferLoad = debounce(function () {
  deferLoad();
}, 250);

window.addEventListener('scroll', debouncedDeferLoad);
